import { useState, useEffect } from "react";

/**
 * Hook personalizado para detectar si el dispositivo es desktop
 *
 * @param {number} breakpoint - Ancho mínimo de pantalla en píxeles para considerar desktop (default: 1280)
 * @returns {boolean} - Retorna true si el ancho de pantalla es mayor o igual al breakpoint especificado
 */
export const useDesktop = (breakpoint = 1280) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkIsDesktop = () => {
      setIsDesktop(window.innerWidth >= breakpoint);
    };

    checkIsDesktop();
    window.addEventListener("resize", checkIsDesktop);

    return () => window.removeEventListener("resize", checkIsDesktop);
  }, [breakpoint]);

  return isDesktop;
};
